import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {currentUserApi} from '../http/Api';

export const getMe = createAsyncThunk('CurrentUser/getMe', async (payload, thunkAPI) => {
  const response = await currentUserApi.getMe();

  if (response.status === 200) {
    thunkAPI.dispatch(currentUserSlice.actions.setMe(response));
  }
});

const initialState = {
  currentUserGlobalState: null,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setMe: (state, action) => {
      state.currentUserGlobalState = action.payload;
    },
  },
});

export const currentUser = currentUserSlice.reducer;
